function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroundwaterWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-7",
    width: 21.166666,
    height: 21.166666,
    x: -3.5527137e-15,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#2e4762",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    d: "m 9.2604085,277.25029 c -4.06655,0.57716 -7.265217,3.77663 -7.842414,7.84345 h 7.842414 z m 2.6458335,0 v 7.84345 h 7.842414 c -0.577196,-4.06682 -3.775863,-7.26629 -7.842414,-7.84345 z M 1.4179945,287.73957 c 0.577197,4.06683 3.775864,7.26629 7.842414,7.84345 v -7.84345 z m 10.4882475,0 v 7.84345 c 4.066551,-0.57716 7.265218,-3.77662 7.842414,-7.84345 z",
    id: "rect4518-8-4-7-1-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroundwaterWell);
export default __webpack_public_path__ + "static/media/icon-groundwater-well.858a88faae5e515332b8c5170082147d.svg";
export { ForwardRef as ReactComponent };